import {
  // Window,
  FunctionHandler,
  FunctionCallback,
  FunctionSuccessCallback,
  JsonData,
} from './akatypes';
// type Window = AkaTypes.Window;
// type FunctionCallback = AkaTypes.FunctionCallback;

import { alertCtk } from './utils';

// const consolelog = console.log;
const consolelog = function foo(x?: any) {};

/*
type MyWindow = Window & {
  jQuery: any;
  cnfg_http_aka_php_base: string;
  cnfg_http_aka_akademieapi_base: string;
};
*/
interface MyWindow extends Window {
  jQuery: any;
  cnfg_http_aka_php_base: string;
  cnfg_http_aka_akademieapi_base: string;
  cnfg_http_aka_tomojectk_base: string;
}
// type FunctionCallback = (r: string) => void;

declare const window: MyWindow;
declare const grecaptcha: any;

const jQuery = window.jQuery;
const cnfg_http_aka_akademieapi_base = window.cnfg_http_aka_akademieapi_base;
const cnfg_http_aka_php_base = window.cnfg_http_aka_php_base;
const cnfg_http_aka_tomojectk_base = window.cnfg_http_aka_tomojectk_base;

export function escapeHtml(text: string) {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

export function escapeString(text: string) {
  return text.replace(/"/g, '"').replace(/'/g, "'");
}

export const checkOkStatusInSuccessFunc = (
  result: string,
  textStatus: string,
  jqXHR: any,
) => {
  consolelog('test returned error');
  const status = jqXHR.status;
  if (status !== 200) {
    alertCtk(
      'Komunikace se serverem selhala, případně byly zadány nepovolené hodnoty!',
    );
    return false; //not ok
  }
  try {
    const parsed = JSON.parse(result.trim());
  } catch (e) {
    alertCtk(
      'Komunikace se serverem selhala, případně byly zadány nepovolené hodnoty.',
    );
    return false; //not ok
  }
  return true; //ok
};

const generalErrorFunc = (
  jqXHR: any,
  textStatus: string,
  errorThrown: string,
) => {
  consolelog('login returned error');
  const status = jqXHR.status;
  if (status !== 200) {
    alertCtk(
      'Komunikace se serverem selhala, případně byly zadány nepovolené hodnoty',
    );
  }
};

export function ajaxSessionInit(
  successFunc: FunctionCallback,
  akasession: string,
) {
  jQuery.ajax({
    xhrFields: { withCredentials: true },
    url:
      cnfg_http_aka_akademieapi_base +
      'sessioninit.php?akasession=' +
      encodeURI(akasession),
    success: successFunc,
  });
}

export async function sessionInitAsync(akasession: string): Promise<any> {
  const data = {};
  const successFunc = (result: string) => {
    consolelog('ajaxSessionInit returned');
    const parsed = JSON.parse(result.trim());
    consolelog(parsed);
    Promise.resolve({
      data: '',
    });
  };
  consolelog(5);
  ajaxSessionInit(successFunc, akasession);
  consolelog(6);
  // setTimeout(() => resolve({ data: [] }), 500),
}

export function ajaxUniGetAsync(
  cmd: string,
  jsondata: JsonData,
  successFunc: FunctionCallback,
  recurseDepth: number = 0,
): Promise<any> {
  return new Promise((resolve, reject) => {
    const successFuncSession = (result: string) => {
      consolelog('session callback, depth=' + recurseDepth);
      const parsed = JSON.parse(result.trim());
      consolelog(parsed);
      const json = { ...parsed };
      if (json.newsession) {
        consolelog('fetching second time with akasession');
        sessionInitAsync(json.newsession).then(() => {
          if (recurseDepth < 3) {
            ajaxUniGetAsync(cmd, jsondata, successFunc, recurseDepth + 1).then(
              (response) => {
                resolve(response);
              },
            ); // recursive
          } else {
            consolelog('break infinite recurse');
            reject(false);
          }
        });
      } else {
        consolelog('resolvuju ajax');
        resolve(successFunc(result));
        // resolve(json);
      }
    };
    jQuery.ajax({
      xhrFields: { withCredentials: true },
      url:
        cnfg_http_aka_akademieapi_base +
        'universal.php?cmd=' +
        cmd +
        '&jsondata=' +
        encodeURIComponent(JSON.stringify(jsondata)),
      success: successFuncSession,
      error: () => {
        consolelog('ajax error');
        reject(false);
      },
    });
  });
}

export function ajaxUniGetUsingCaptchaAsync(
  cmd: string,
  jsondata: JsonData,
  successFunc: FunctionCallback,
  recaptchaActionName: string,
): Promise<any> {
  return new Promise((resolve, reject) => {
    grecaptcha.ready(function () {
      const gre = grecaptcha.execute(
        '6LeJb-AeAAAAAAfPGWKTjUyTPIe9T5vU26zxWmYQ',
        {
          //beta akademie code
          action: recaptchaActionName,
        },
      );
      gre.then(function (grecaptchatoken: string) {
        // Add your logic to submit to your backend server here.
        consolelog('captcha then');
        ajaxUniGetCaptchaAsync(cmd, jsondata, successFunc, grecaptchatoken)
          .then((result) => {
            resolve(result);
          })
          .catch(() => {
            resolve({ status: 'badajax' });
          });
      });
      gre.catch((ex: any) => {
        consolelog('captcha catch: ' + ex);
        resolve({ status: 'catchbadcaptcha' });
      });
    });
  });
}

export function ajaxUniGetCaptchaAsync(
  cmd: string,
  jsondata: JsonData,
  successFunc: FunctionCallback,
  grecaptchatoken: string,
  recurseDepth: number = 0,
): Promise<any> {
  return new Promise((resolve, reject) => {
    const successFuncSession = (result: string) => {
      consolelog('session callback, depth=' + recurseDepth);
      const parsed = JSON.parse(result.trim());
      consolelog(parsed);
      const json = { ...parsed };
      if (json.newsession) {
        consolelog('fetching second time with akasession');
        const ff = sessionInitAsync(json.newsession);
        ff.then(() => {
          if (recurseDepth < 3) {
            // recursive
            const f = ajaxUniGetCaptchaAsync(
              cmd,
              jsondata,
              successFunc,
              grecaptchatoken,
              recurseDepth + 1,
            );
            f.then((response) => {
              resolve(response);
            });
          } else {
            consolelog('break infinite recurse');
            reject(false);
          }
        });
      } else {
        consolelog('resolvuju ajax');
        resolve(successFunc(result));
        // resolve(json);
      }
    };

    jQuery.ajax({
      xhrFields: { withCredentials: true },
      url:
        cnfg_http_aka_akademieapi_base +
        'universal.php?cmd=' +
        cmd +
        '&jsondata=' +
        encodeURIComponent(JSON.stringify(jsondata)) +
        '&grecaptchatoken=' +
        encodeURIComponent(grecaptchatoken),
      success: successFuncSession,
      error: () => {
        consolelog('ajax error');
        reject(false);
      },
    });
  });
}

export function ajaxUniPostUsingCaptcha(
  cmd: string,
  jsondata: JsonData,
  successFunc: FunctionCallback,
  recaptchaActionName: string,
) {
  grecaptcha.ready(function () {
    grecaptcha
      .execute('6LeJb-AeAAAAAAfPGWKTjUyTPIe9T5vU26zxWmYQ', {
        //beta akademie code
        action: recaptchaActionName,
      })
      .then(function (grecaptchatoken: string) {
        // Add your logic to submit to your backend server here.
        ajaxUniPostCaptcha(cmd, jsondata, successFunc, grecaptchatoken);
      });
  });
}

function ajaxUniPostCaptcha(
  cmd: string,
  jsondata: JsonData,
  successFunc: FunctionCallback,
  grecaptchatoken: string,
) {
  jQuery.ajax({
    type: 'POST',
    url: cnfg_http_aka_akademieapi_base + 'universalpost.php',
    data: {
      cmd,
      jsondata: JSON.stringify(jsondata),
      grecaptchatoken: grecaptchatoken,
    },
    success: successFunc,
  });
}
export function ajaxUniPost(
  cmd: string,
  jsondata: JsonData,
  successFunc: FunctionCallback,
) {
  jQuery.ajax({
    type: 'POST',
    url: cnfg_http_aka_akademieapi_base + 'universalpost.php',
    data: { cmd, jsondata: JSON.stringify(jsondata) },
    success: successFunc,
  });
}
export function ajaxPlatebniBranaAkaPost(jsondata: JsonData, crc: string) {
  const redirect = window.cnfg_http_aka_php_base + 'final.php'; // http://localhost/ctk24/final.php
  //const url1 =    'https://shop.ctk.cz/platba?src=CTK24&redirect=' +    redirect +    '&data=' +    encodeURI(JSON.stringify(res));
  // + '&crc=' +  parsed.crc;
  submitPostNonAjax('https://shop.ctk.cz/platba', 'POST', [
    { name: 'src', value: 'AKA' },
    { name: 'data', value: JSON.stringify(jsondata) },
    { name: 'redirect', value: redirect },
    { name: 'cr', value: crc },
  ]);
}

export const ajaxUniPut = ajaxUniPost;
export const ajaxUniDelete = ajaxUniPost;

export function ajaxLoginUsingCaptcha(
  email: string,
  jsondata: JsonData,
  successFunc: FunctionSuccessCallback,
) {
  grecaptcha.ready(function () {
    grecaptcha
      .execute('6LeJb-AeAAAAAAfPGWKTjUyTPIe9T5vU26zxWmYQ', { action: 'login' })
      .then(function (grecaptchatoken: string) {
        // Add your logic to submit to your backend server here.
        jQuery.ajax({
          type: 'POST',
          url: cnfg_http_aka_akademieapi_base + 'login.php',
          data: {
            email,
            jsondata: JSON.stringify(jsondata),
            grecaptchatoken: grecaptchatoken,
          },
          success: successFunc,
          error: generalErrorFunc,
        });
      });
  });
}

export function ajaxLogout(successFunc: FunctionCallback) {
  jQuery.ajax({
    xhrFields: { withCredentials: true },
    url: cnfg_http_aka_akademieapi_base + 'logout.php',
    success: successFunc,
  });
}

export function submitPostNonAjax(action: string, method: string, values: any) {
  var form = jQuery('<form/>', {
    action: action,
    method: method,
  });
  jQuery.each(values, function (this: any) {
    form.append(
      jQuery('<input/>', {
        type: 'hidden',
        name: this.name,
        value: this.value,
      }),
    );
  });
  form.appendTo('body').submit();
}
